var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFastApply = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "url(#fast-apply_svg__a)",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#292929",
  d: "M9.877 5.85 11 3H5v10h2.481v-2.787h2.803V7.425H7.481V5.85z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fast-apply_svg__a",
  x1: 0,
  x2: 16,
  y1: 0,
  y2: 16,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE140"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC829"
})))));
export default SvgFastApply;